import React from 'react';
import { useLanguage } from '../../contexts/LanguageContext';

const QuickLinks = ({ scrollToSection }) => {
  const { t } = useLanguage();

  const links = [
    { label: t.nav?.home || 'Anasayfa', id: 'home' },
    { label: t.footer?.about || 'Hakkımızda', id: 'about' },
    { label: t.footer?.services || 'Hizmetlerimiz', id: 'services' },
    { label: t.nav?.blog || 'Blog', id: 'blog' }
  ];

  return (
    <div>
      <h3 className="text-white font-semibold mb-4">
        {t.language === 'tr' ? 'Hızlı Bağlantılar' : 'Quick Links'}
      </h3>
      <ul className="space-y-2">
        {links.map((link) => (
          <li key={link.id}>
            <button
              onClick={() => scrollToSection(link.id)}
              className="text-gray-400 hover:text-orange-400 transition-colors text-sm"
            >
              {link.label}
            </button>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default QuickLinks;
